<template>
  <v-dialog
    v-bind="$attrs"
    v-model="dialog"
    :overlay="false"
    transition="dialog-transition"
    max-width="640"
    overlay-opacity="0.8"
    content-class="marginBottomHack"
  >
    <v-card max-width="640" class="pa-0">
      <v-text-field
        solo
        dense
        autofocus
        full-width
        label="Pesquise aqui"
        hide-details
        append-icon="mdi-magnify"
        v-model="termoPesquisa"
        @click:append="pesquisarProdutosClick"
        @keydown.native="pesquisarProdutos"
      />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "tamanhos-cores",

  data() {
    return {
      dialog: false,
      termoPesquisa: ""
    };
  },

  methods: {
    abrir(value) {
      this.dialog = true;
    },

    fechar() {
      this.dialog = false;
    },

    pesquisarProdutos(key) {
      this.termoPesquisa = this.termoPesquisa.trimStart();
      if (key.code === "Enter") {
        this.$store.commit("setFiltro", { termoPesquisa: this.termoPesquisa });
        this.dialog = false;
      }
    },

    pesquisarProdutosClick(key) {
      this.termoPesquisa = this.termoPesquisa.trimStart();
      this.$store.commit("setFiltro", { termoPesquisa: this.termoPesquisa });
      this.dialog = false;
    }
  },
  watch: {
    "$store.state.filtro": {
      handler: function(filtro) {
        this.termoPesquisa = filtro.termoPesquisa;
      },
      deep: true
    }
  }
};
</script>

<style>
.marginBottomHack {
  margin-bottom: 80vh !important;
}
</style>
